exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navigation {\n    cursor: pointer;\n    display: inline-block;\n    padding: 9px 5px;\n    border-radius: 2px;\n    color: #fff !important;\n    line-height: 16px;\n    font-size:14px;\n    text-decoration: none !important;\n    font-family:Gotham, \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.addTimesheet {\n    margin-top: 8px;\n\tmargin-right: 10px;\n\twidth: 18px;\n\theight: 18px;\n}\n\n.pageWidth {\n\tmargin-left: 1%;\n\tmargin-right: auto;\n\twidth: 98%;\n}\n\n.mat-menu-item {\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    outline: 0;\n    border: none;\n    white-space: nowrap;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    display: block;\n    line-height: 30px;\n    height: 30px;\n    padding: 0 16px;\n    font-size: 16px;\n    font-family: Roboto,\"Helvetica Neue\",sans-serif;\n    text-align: start;\n    text-decoration: none;\n    position: relative;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/header/navigationbar/navigation-bar.component.css
// module id = 2012
// module chunks = 0